export default __webpack_public_path__ + "static/blob12-ce9897735ae2ca6f39b26ae614c2df38.svg";